import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';

import { IAssociatedClinic,IAssociatedClinicRes } from '../patients/index.type';

const useFetchAssociatedClinic = ({ clinicId }: { clinicId: string }) => {
  const [associatedClinic, setAssociatedClinic] = React.useState<IAssociatedClinic[]>([]);

  const { loading: associatedClinicLoading, makeApiCall } = useApi({
   url: `/rtm/associated-clinic/enable/${clinicId}`,
    method: 'GET',
  });

  const getAssociatedClinic = async () => {
    const { response, error } = await makeApiCall<undefined,IAssociatedClinicRes>();

    if (response?.status) {
      setAssociatedClinic(response.data || []);
    } else {
      setAssociatedClinic([]);
    }

    if (error) {
      toast.error(error.msg || 'Unable to load associated clinic information. Please refresh the page or try again later.');
    }
  };

  return {
    associatedClinic,
    getAssociatedClinic,
    associatedClinicLoading,
  };
};

export default useFetchAssociatedClinic;
